export default "__VITE_ASSET__YwQoEJws__"